
import CustomModal from "../CustomModal";
import DatePicker from "react-datepicker";
import { useLocations } from "../../../hooks/useLocations";

const AddMemberModal = ({
  isOpen,
  onRequestClose,
  step,
  memberData,
  handleInputChange,
  handleDateChange,
  handleFileChange,
  handleNext,
  handlePrevious,
  handleComplete,
  profileImage,
  imageUploading,
  errors,
}) => {

  const { locations, loading: loadingLocations } = useLocations(isOpen, { includeRoleFiltering: true });

  const handleLocationChange = (e) => {
    handleInputChange({ target: { name: "location", value: e.target.value } });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="add-admin-modal container-fluid"
    >
      <div className="form-container">
        {step === 1 && (
          <div className="inner-form">
            <div className="add-staff-head">
              <h2>Member Details</h2>
              <div className="form-step-indicator">
                <p>Page {step} of 3</p>
                <div className="step-indicator-container">
                  <span
                    className={`step ${
                      step === 1
                        ? "active"
                        : step > 1
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                  <span className="divider"></span>
                  <span
                    className={`step ${
                      step === 2
                        ? "active"
                        : step > 2
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                  <span className="divider"></span>
                  <span
                    className={`step ${
                      step === 3
                        ? "active"
                        : step > 3
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                </div>
              </div>
            </div>
            <div className="add-staff-image">
              <div className="add-staff-image-pic">
                <img
                  src={profileImage}
                  alt="Profile Preview"
                  width="36px"
                  height="36px"
                />
                <div className="add-staff-image-text">
                  <p>Upload member's picture</p>
                  <p>PNG OR JPG</p>
                </div>
              </div>
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="upload-picture"
                disabled={imageUploading}
              />
              <label
                htmlFor="upload-picture"
                style={{
                  cursor: imageUploading ? "not-allowed" : "pointer",
                  opacity: imageUploading ? 0.6 : 1,
                }}
              >
                {imageUploading ? "Uploading..." : "Upload picture"}
              </label>
            </div>
            <div className="form-input">
              <div className="member-name">
                <div id="member-fname">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    id="firstName"
                    name="firstName"
                    value={memberData.firstName}
                    onChange={handleInputChange}
                    required
                    type="text"
                  />
                </div>
                <div id="member-lname">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    id="lastName"
                    name="lastName"
                    value={memberData.lastName}
                    onChange={handleInputChange}
                    required
                    type="text"
                  />
                </div>
              </div>
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                id="phoneNumber"
                name="phoneNumber"
                value={memberData.phoneNumber}
                onChange={handleInputChange}
                required
                type="text"
                maxLength="11"
                style={{
                  borderColor: errors.phoneNumber ? "red" : "initial",
                  marginBottom: "0",
                }}
              />
              {errors.phoneNumber && (
                <small
                  style={{
                    color: "red",
                    fontSize: "10px",
                    marginBottom: "2px",
                  }}
                >
                  {errors.phoneNumber}
                </small>
              )}
              <br />
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                value={memberData.email}
                onChange={handleInputChange}
                required
                type="email"
              />
              <label htmlFor="address">Address</label>
              <input
                id="address"
                name="address"
                value={memberData.address}
                onChange={handleInputChange}
                required
                type="text"
              />

              <label htmlFor="location">Location</label>
              <select
                id="location"
                name="location"
                value={memberData.location || ''}
                onChange={handleLocationChange}
                required
                disabled={loadingLocations}
                style={{ marginBottom: 12 }}
              >
                <option value="" disabled>
                  {loadingLocations ? 'Loading locations...' : 'Select a location'}
                </option>
                {locations.map(loc => (
                  <option key={loc.id} value={loc.id}>{loc.name}</option>
                ))}
              </select>
              <label htmlFor="dateOfBirth">Date of Birth</label>
              <div className="date-picker">
                <DatePicker
                  selected={memberData.dateOfBirth}
                  onChange={(date) => handleDateChange(date, "dateOfBirth")}
                  showPopperArrow={false}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select a date"
                />
              </div>
              <label htmlFor="profession">Profession</label>
              <input
                id="profession"
                name="profession"
                value={memberData.profession}
                onChange={handleInputChange}
                required
                type="text"
              />
              <label htmlFor="NIN">National Identification Number (NIN)</label>
              <input
                id="NIN"
                name="NIN"
                value={memberData.NIN}
                onChange={handleInputChange}
                required
                type="text"
                maxLength="11"
                style={{
                  borderColor: errors.NIN ? "red" : "initial",
                  marginBottom: "0",
                }}
              />
              {errors.NIN && (
                <small
                  style={{
                    color: "red",
                    fontSize: "10px",
                    marginBottom: "2px",
                  }}
                >
                  {errors.NIN}
                </small>
              )}
            </div>
            <div className="modal-button">
              <button onClick={onRequestClose}>Cancel</button>
              <button onClick={handleNext}>Next</button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="inner-form">
            <div className="add-staff-head">
              <h2>Member Details</h2>
              <div className="form-step-indicator">
                <p>Page {step} of 3</p>
                <div className="step-indicator-container">
                  <span
                    className={`step ${
                      step === 1
                        ? "active"
                        : step > 1
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                  <span className="divider"></span>
                  <span
                    className={`step ${
                      step === 2
                        ? "active"
                        : step > 2
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                  <span className="divider"></span>
                  <span
                    className={`step ${
                      step === 3
                        ? "active"
                        : step > 3
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                </div>
              </div>
            </div>
            <div className="form-input">
              <label htmlFor="startWeight">Start Weight (kg)</label>
              <input
                id="startWeight"
                name="startWeight"
                value={memberData.startWeight}
                onChange={handleInputChange}
                placeholder="weight in kg"
                required
                type="number"
              />
              <label htmlFor="startHeight">Start Height (cm)</label>
              <input
                id="startHeight"
                name="startHeight"
                value={memberData.startHeight}
                onChange={handleInputChange}
                placeholder="height in cm"
                required
                type="number"
              />
              <label htmlFor="bodySize">Body Size</label>
              <input
                id="bodySize"
                name="bodySize"
                value={memberData.bodySize}
                onChange={handleInputChange}
                placeholder="body size in digits"
                required
                type="number"
              />
            </div>
            <div className="modal-button">
              <button onClick={handlePrevious}>Back</button>
              <button onClick={handleNext}>Next</button>
            </div>
          </div>
        )}
        {step === 3 && (
          <div className="inner-form">
            <div className="add-staff-head">
              <h2>Member Details</h2>
              <div className="form-step-indicator">
                <p>Page {step} of 3</p>
                <div className="step-indicator-container">
                  <span
                    className={`step ${
                      step === 1
                        ? "active"
                        : step > 1
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                  <span className="divider"></span>
                  <span
                    className={`step ${
                      step === 2
                        ? "active"
                        : step > 2
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                  <span className="divider"></span>
                  <span
                    className={`step ${
                      step === 3
                        ? "active"
                        : step > 3
                        ? "completed"
                        : "inactive"
                    }`}
                  ></span>
                </div>
              </div>
            </div>
            <div className="member-preview-head">
              <img
                style={{ borderRadius: "50%" }}
                src={memberData.profileImage}
                alt="Profile Preview"
                width="48px"
                height="48px"
              />
              <p>
                {memberData.firstName} {memberData.lastName}
              </p>
            </div>
            <p
              style={{
                marginLeft: "23px",
                marginBottom: "4px",
                marginTop: "24px",
                color: "#8C8C8C",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              Personal Information
            </p>
            <div
              style={{ marginTop: "0" }}
              className="details-container container"
            >
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_dob.png`}
                    alt="Date of birth"
                  />
                  <p>Date of Birth</p>
                </span>
                <b>
                  <p className="D">
                    {memberData.dateOfBirth
                      ? new Date(memberData.dateOfBirth).toLocaleDateString()
                      : ""}
                  </p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_address.png`}
                    alt="Address"
                  />
                  <p>Home Address</p>
                </span>
                <b>
                  <p className="D">{memberData.address}</p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/location.png`}
                    alt="Location"
                  />
                  <p>Gym Location</p>
                </span>
                <b>
                  <p className="D">
                    {(() => {
                      if (!memberData.location) return '';
                      const found = locations.find(l => String(l.id) === String(memberData.location));
                      return found ? found.name : memberData.location;
                    })()}
                  </p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_profession.png`}
                    alt="Profession"
                  />
                  <p>Profession</p>
                </span>
                <b>
                  <p className="D">{memberData.profession}</p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_email.png`}
                    alt="Email"
                  />
                  <p>Email</p>
                </span>
                <b>
                  <p className="D">{memberData.email}</p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_mobile.png`}
                    alt="Mobile"
                  />
                  <p>Phone Number</p>
                </span>
                <b>
                  <p className="D">{memberData.phoneNumber}</p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_nin.png`}
                    alt="NIN"
                  />
                  <p>NIN</p>
                </span>
                <b>
                  <p className="D">{memberData.NIN}</p>
                </b>
              </div>
            </div>
            <p
              style={{
                marginLeft: "23px",
                marginBottom: "4px",
                marginTop: "24px",
                color: "#8C8C8C",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              Gym Information
            </p>
            <div
              style={{ marginTop: "0" }}
              className="details-container container"
            >
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_weight.png`}
                    alt="Weight"
                  />
                  <p>Start Weight</p>
                </span>
                <b>
                  <p className="D">{memberData.startWeight}kg</p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_nin.png`}
                    alt="Height"
                  />
                  <p>Start Height</p>
                </span>
                <b>
                  <p className="D">{memberData.startHeight}cm</p>
                </b>
              </div>
              <div className="detail">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/user_size.png`}
                    alt="Size"
                  />
                  <p>Body Size</p>
                </span>
                <b>
                  <p className="D">Size {memberData.bodySize}</p>
                </b>
              </div>
            </div>
            <div className="modal-button">
              <button onClick={handlePrevious}>Back</button>
              <button onClick={handleComplete}>Complete</button>
            </div>
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default AddMemberModal;
